'use strict';

function getAddon(addon) {
  return {
    tag: 'span',
    attrs: {
      className: {
        'input-group-addon': true
      }
    },
    children: addon
  };
}

module.exports = getAddon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getAddon.js
 ** module id = 1060
 ** module chunks = 0
 **/